// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__dtpRy","obliqueLineWrap":"membershipbadge_obliqueLineWrap__32NAi","obliqueLine":"membershipbadge_obliqueLine__16lKL"};